export default {
  applicant: 'applicant',
  pass: 'pass',
  visitors: 'visitors',
  edit: 'edit',
  apply: 'apply',
  approve: 'approve'
}
